"use strict";

export const NativeHandlerNativeProperties = new Set(['shouldActivateOnStart', 'disallowInterruption', 'yieldsToContinuousGestures', 'delaysChildPressedState']);
//# sourceMappingURL=NativeTypes.js.map